<template>
  <div class="container">
    <div class="images-wrapper">
      <draggable v-model="myList" :options="{group:'modelList', dragClass: 'dragging', chosenClass: 'chosing'}"
                 class="drag" @remove="handleRemove">
        <transition-group>
          <div class="image-item-wrapper"
            v-for="image in currentImages()"
            :key="image.dish_img_uuid">
            <image-item @mark="handleMark" @unMark="handleUnmark" @delete="handleDelete"
                      :dish_img_uuid="image.dish_img_uuid"
                      :image="image">
            </image-item>
          </div>
        </transition-group>
      </draggable>
    </div>
    <!-- </lazy-render> -->
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handlePagination"
        :page-count="maxSize"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import imageItem from '_c/imageItem';
import {mapMutations} from 'vuex';
// import {errorMessage, successMessage} from '@/lib/msg';
import draggable from 'vuedraggable';

export default {
  name: 'imageMarkWrapper',
  components: {
    imageItem,
    draggable
  },
  props: {
    images: {
      tyep: Array,
      default () {
        return [];
      }
    },
    current_class_id: ''
  },
  data () {
    return {
      pageSize: 60,
      currentPage: 1
    };
  },
  mounted () {
    setTimeout(() => {
      this.setUnMarkedImageList(this.images);
    }, 1000);
  },
  methods: {
    ...mapMutations([
      'mark',
      'unMark',
      'delete',
      'setUnMarkedImageList'
    ]),
    handleRemove (e) {
      this.$emit('dragging', e.to);
    },
    handleDelete ({dish_img_uuid}) {
      this.delete(dish_img_uuid);
    },
    handlePagination (index) {
      this.currentPage = index;
    },
    handleMark (dish_img_uuid) {
      this.mark({dish_img_uuid, class_id: this.current_class_id});
    },
    handleUnmark ({dish_img_uuid, class_id}) {
      if (this.current_class_id === class_id) {
        this.unMark({dish_img_uuid, class_id});
      } else {
        this.$confirm('本图片被其它例图标记, 是否继续删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unMark({dish_img_uuid, class_id});
        }
        ).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    currentImages () {
      return this.myList.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    }
  },
  computed: {
    maxSize () {
      return Math.ceil(this.myList.length / this.pageSize);
    },

    myList: {
      get: function () {
        return this.$store.state.unMarkedImageList;
      },
      set: function (value) {
        this.setUnMarkedImageList(value);
      }
    }
  },
  watch: {
    current_class_id () {
      this.$nextTick(() => {
        this.currentPage = 1;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    position: relative;
    margin: 10px;
    .images-wrapper {
      display: inline-block;
      border: 3px solid #ccc;
      width: 100%;
      min-height: 50vh;
      .image-item-wrapper {
        display: inline-block;
      }
      .drag {
        .dragging {
          background-color: $success;
        }
        .chosing {
          background-color: $success;
        }
      }
    }
    .pagination {
      margin: 10px 0;
      width: 100%;
      text-align: center;
    }
  }
</style>
